export default {"src":"/_next/static/media/section1.e3fda934.svg","height":561,"width":1316,"blurWidth":0,"blurHeight":0};